import truckTireService, { TruckTireFilters } from '../../services/truckTireService';

export const GET_TRUCK_TIRES = "GET_TRUCK_TIRES";
export const GET_TRUCK_TIRE = "GET_TRUCK_TIRE";
export const GET_TRUCK_TIRE_CATEGORIES = "GET_TRUCK_TIRE_CATEGORIES";
export const GET_TRUCK_TIRE_BRANDS = "GET_TRUCK_TIRE_BRANDS";
export const CREATE_TRUCK_TIRE = "CREATE_TRUCK_TIRE";
export const UPDATE_TRUCK_TIRE = "UPDATE_TRUCK_TIRE";
export const DELETE_TRUCK_TIRE = "DELETE_TRUCK_TIRE";
export const SET_TRUCK_TIRE_LOADING = "SET_TRUCK_TIRE_LOADING";
export const SET_TRUCK_TIRE_ERROR = "SET_TRUCK_TIRE_ERROR";

// Tüm kamyon lastiklerini getir
export const getTruckTires = (filters: TruckTireFilters = {}) => async (dispatch: any) => {
    try {
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: true });
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: null });
        
        const response = await truckTireService.getAllTruckTires(filters);
        
        dispatch({
            type: GET_TRUCK_TIRES,
            payload: response.data
        });
        
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        return response.data;
    } catch (error: any) {
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: error.message });
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        throw error;
    }
};

// Kategoriye göre kamyon lastikleri getir
export const getTruckTiresByCategory = (grup: string, filters: Omit<TruckTireFilters, 'grup'> = {}) => async (dispatch: any) => {
    try {
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: true });
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: null });
        
        const response = await truckTireService.getTruckTiresByCategory(grup, filters);
        
        dispatch({
            type: GET_TRUCK_TIRES,
            payload: response.data
        });
        
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        return response.data;
    } catch (error: any) {
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: error.message });
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        throw error;
    }
};

// Tek kamyon lastiği getir
export const getTruckTire = (id: string | number) => async (dispatch: any) => {
    try {
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: true });
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: null });
        
        const response = await truckTireService.getTruckTireById(id);
        
        dispatch({
            type: GET_TRUCK_TIRE,
            payload: response.data
        });
        
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        return response.data;
    } catch (error: any) {
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: error.message });
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        throw error;
    }
};

// Kamyon lastik kategorilerini getir
export const getTruckTireCategories = () => async (dispatch: any) => {
    try {
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: true });
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: null });
        
        const response = await truckTireService.getTruckTireCategories();
        
        dispatch({
            type: GET_TRUCK_TIRE_CATEGORIES,
            payload: response.data
        });
        
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        return response.data;
    } catch (error: any) {
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: error.message });
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        throw error;
    }
};

// Kamyon lastik markalarını getir
export const getTruckTireBrands = () => async (dispatch: any) => {
    try {
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: true });
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: null });
        
        const response = await truckTireService.getTruckTireBrands();
        
        dispatch({
            type: GET_TRUCK_TIRE_BRANDS,
            payload: response.data
        });
        
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        return response.data;
    } catch (error: any) {
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: error.message });
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        throw error;
    }
};

// Admin: Kamyon lastiği oluştur
export const createTruckTire = (truckTireData: any) => async (dispatch: any) => {
    try {
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: true });
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: null });
        
        const response = await truckTireService.createTruckTire(truckTireData);
        
        dispatch({
            type: CREATE_TRUCK_TIRE,
            payload: response.data
        });
        
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        return response.data;
    } catch (error: any) {
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: error.message });
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        throw error;
    }
};

// Admin: Kamyon lastiği güncelle
export const updateTruckTire = (id: string | number, truckTireData: any) => async (dispatch: any) => {
    try {
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: true });
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: null });
        
        const response = await truckTireService.updateTruckTire(id, truckTireData);
        
        dispatch({
            type: UPDATE_TRUCK_TIRE,
            payload: response.data
        });
        
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        return response.data;
    } catch (error: any) {
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: error.message });
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        throw error;
    }
};

// Admin: Kamyon lastiği sil
export const deleteTruckTire = (id: string | number) => async (dispatch: any) => {
    try {
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: true });
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: null });
        
        const response = await truckTireService.deleteTruckTire(id);
        
        dispatch({
            type: DELETE_TRUCK_TIRE,
            payload: id
        });
        
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        return response;
    } catch (error: any) {
        dispatch({ type: SET_TRUCK_TIRE_ERROR, payload: error.message });
        dispatch({ type: SET_TRUCK_TIRE_LOADING, payload: false });
        throw error;
    }
};
